// extracted by mini-css-extract-plugin
module.exports =  {"borders":"borders__3cuZQ","buttons":"buttons__GnXb6","body":"body__VBWxZ","input":"input__8SvuU","descriptionDivider":"descriptionDivider__rGlkf"};